export default __webpack_public_path__ + "static/media/fondo.681fe994.mov";